import { Container, Loader } from "../../../components";

export const Loading: view = ({ }) => {
  return (
    <Container>
      <Loader />
    </Container>
  )
};

